import {gsap} from "../LibrariesImport";

export default class BlockSlider {
	static init() {

		let blocks = document.querySelectorAll('.block-projects-highlight');

		blocks.forEach( (block) => {

			const container = block.querySelector('.swiper-container');
			const swiper = block.querySelector('.swiper-main-slider');
			const pagination = block.querySelector('.swiper-pagination');
			const navigationPrev = block.querySelector('.swiper-navigation .prev');
			const navigationNext = block.querySelector('.swiper-navigation .next');

			new Swiper(swiper, {
				autoplay: true,
				slidesPerView: "1",
				grabCursor: true,
				effect: 'fade',
				speed: 1500,
				loop: true,
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					prevEl: navigationPrev,
					nextEl: navigationNext,
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				}
			});

			let mm = gsap.matchMedia();
			mm.add("(max-width: 767px)", () => {
				container.classList.remove('section-color-transparent');
			});
			mm.add("(min-width: 768px)", () => {
				container.classList.add('section-color-transparent');
			});

		});

	}
}
